import { BIG_ZERO } from "@perp/sdk-curie"
import Big from "big.js"
import { useEffect, useState } from "react"

export const useRankingTier = (marketTotalLowerAprVal: string, marketTotalUpperAprVal: string) => {
    const [tickOne, setTickOne] = useState<Big>(BIG_ZERO)
    const [tickTwo, setTickTwo] = useState<Big>(BIG_ZERO)
    const [tickThree, setTickThree] = useState<Big>(BIG_ZERO)
    const [rankRangeOneStr, setRankRangeOneStr] = useState<string>("")
    const [rankRangeTwoStr, setRankRangeTwoStr] = useState<string>("")
    const [rankRangeThreeStr, setRankRangeThreeStr] = useState<string>("")
    const [rankRangeFourStr, setRankRangeFourStr] = useState<string>("")

    useEffect(() => {
        const rangeTick = new Big(marketTotalUpperAprVal).minus(marketTotalLowerAprVal).div(4)
        const tickOne = new Big(marketTotalLowerAprVal).plus(rangeTick.mul(1))
        const tickTwo = new Big(marketTotalLowerAprVal).plus(rangeTick.mul(2))
        const tickThree = new Big(marketTotalLowerAprVal).plus(rangeTick.mul(3))
        const rankRangeOneStr = `${new Big(marketTotalLowerAprVal).toFixed(1).toString()}% - ${new Big(tickOne)
            .toFixed(1)
            .toString()}%`
        const rankRangeTwoStr = `${new Big(tickOne).toFixed(1).toString()}% - ${new Big(tickTwo)
            .toFixed(1)
            .toString()}%`
        const rankRangeThreeStr = `${new Big(tickTwo).toFixed(1).toString()}% - ${new Big(tickThree)
            .toFixed(1)
            .toString()}%`
        const rankRangeFourStr = `${new Big(tickThree).toFixed(1).toString()}% - ${new Big(marketTotalUpperAprVal)
            .toFixed(1)
            .toString()}%`

        setTickOne(tickOne)
        setTickTwo(tickTwo)
        setTickThree(tickThree)
        setRankRangeOneStr(rankRangeOneStr)
        setRankRangeTwoStr(rankRangeTwoStr)
        setRankRangeThreeStr(rankRangeThreeStr)
        setRankRangeFourStr(rankRangeFourStr)
    }, [marketTotalUpperAprVal, marketTotalLowerAprVal])
    return {
        tickOne,
        tickTwo,
        tickThree,
        rankRangeOneStr,
        rankRangeTwoStr,
        rankRangeThreeStr,
        rankRangeFourStr,
    }
}
